import { useState, useRef, useEffect } from "react";
import {
  Button, Card, Flex, Input, Space, Spin, Typography
} from "antd";
import { SendOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { Trans, useTranslation } from "react-i18next";
import useChat from "./useChat";
import classes from "./chat.module.css";

const { Search } = Input;
const { Text } = Typography;

const Chat = () => {
  const { t } = useTranslation();
  const {
    messages,
    isChatLoading,
    isSendLoading,
    sendMessage,
    isUserMessage
  } = useChat();
  const messagesBlockRef = useRef<HTMLDivElement>(null);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (messagesBlockRef.current) {
      messagesBlockRef.current.scrollTop = messagesBlockRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <Card styles={{ body: { height: "100%" } }} style={{ height: "100%" }}>
      {isChatLoading
        ? <Flex justify="center" align="center" style={{ height: "100%", width: "100%" }}><Spin/></Flex>
        : (
          <Flex vertical style={{ height: "100%" }}>
            <Flex ref={messagesBlockRef} vertical gap={16} style={{ overflow: "auto", height: "100%", marginBottom: 16 }}>
              <Text className={classes.firstMessage}>
                <Trans
                  i18nKey="messagesPage.chatInfo"
                  components={{ strong: <strong /> }}
                />
              </Text>
              {messages !== null ? messages.map((message) => (
                <Space
                  key={message.id}
                  direction="vertical"
                  className={
                    isUserMessage(message.from) ? classes.userMessage : classes.contactMessage
                  }
                >
                  <Text style={{ color: "inherit", fontSize: 12 }}>
                    {dayjs(message.created_at).format("DD/M/YYYY, hh:mm").toString()}
                  </Text>
                  <Text style={{ color: "inherit", fontSize: 16 }}>{message.content}</Text>
                </Space>
              )) : <Text>{t("messagesPage.noMessages")}</Text>}
            </Flex>
            <Search
              placeholder={t("messagesPage.chatInputPlaceholder")}
              allowClear={false}
              size="large"
              enterButton={(
                <Button
                  type="primary"
                  icon={<SendOutlined/>}
                  disabled={!(inputValue.length) || isSendLoading}
                  loading={isSendLoading}
                />
              )}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onSearch={(value) => {
                if (inputValue.length) {
                  sendMessage(value).then(() => {
                    setInputValue("");
                  });
                }
              }}
            />
          </Flex>
        )}
    </Card>
  );
};

export default Chat;
